/**
 * @file 为组件添加固定的className的HOC
 * @author zhanglili
 */

import classNames from 'classnames';
import {wrapDisplayName} from 'recompose';

export default (extraClassName, displayName) => Component => {
    const WrappedComponent = ({className, ...props}) => (
        <Component
            {...props}
            className={classNames(className, extraClassName)}
        />
    );
    WrappedComponent.displayName = displayName || wrapDisplayName(Component, 'withClassName');
    return WrappedComponent;
};
